import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busrentalforcorporateeventsinpune() {



const cardData = {
  keyword: "Bus Rental for Corporate Events in Pune",

"headingDescription": "SRS Cab Service offers Bus Rental for Corporate Events in Pune, providing safe, reliable, and comfortable transportation for large teams, conferences, seminars, and corporate gatherings. Our fleet of well-maintained buses and professional drivers ensures timely pickups, smooth travel, and hassle-free commuting for employees and clients. With flexible routes, transparent pricing, and 24/7 customer support, SRS Cab Service makes corporate event transportation in Pune efficient, convenient, and stress-free.",
"topPlaces": [
  {
    "title": "Pune International Convention Center",
    "description": "A key venue for corporate conferences and large events. Companies rely on SRS Cab Service buses to transport employees and guests efficiently and comfortably."
  },
  {
    "title": "JW Marriott Pune",
    "description": "A popular hotel for corporate meetings and events. SRS Cab Service provides bus rentals for group transfers to and from JW Marriott Pune."
  },
  {
    "title": "Hyatt Pune",
    "description": "Frequent corporate gatherings are held here. SRS Cab Service ensures timely and professional bus services for attendees."
  },
  {
    "title": "ICC Trade Tower",
    "description": "Corporate seminars and workshops take place here. SRS Cab Service provides buses to safely and comfortably transport employees and clients."
  },
  {
    "title": "Phoenix Market City Pune",
    "description": "Used for corporate launches and business events. SRS Cab Service offers group bus rentals for smooth commuting."
  },
  {
    "title": "Renaissance Pune Hotel",
    "description": "A premium venue for corporate events. SRS Cab Service provides reliable bus transport for teams and guests attending conferences."
  },
  {
    "title": "The Westin Pune Koregaon Park",
    "description": "Corporate meetings and team-building events often happen here. SRS Cab Service ensures comfortable group travel for employees and clients."
  },
  {
    "title": "Balewadi Stadium",
    "description": "Venue for corporate gatherings and large team events. SRS Cab Service provides efficient bus rental services for corporate teams."
  },
  {
    "title": "Swissotel Pune",
    "description": "A preferred location for business meetings and corporate events. SRS Cab Service offers buses for reliable and timely transportation."
  },
  {
    "title": "PCMC Club and Conference Halls",
    "description": "Used for workshops and corporate seminars. SRS Cab Service ensures seamless group transportation with our bus rental services."
  }
],



services: [
{
name: "Bus Rental for Corporate Events in Pune",
description: "Bus rental for corporate events in Pune offers reliable transport for business gatherings and functions. Companies can book buses for employees and guests. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with event bus services."
},
{
name: "Corporate Event Bus Rental Pune",
description: "Corporate event bus rental Pune provides organized group transport for business events and conferences. Companies can manage travel efficiently. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible scheduling options are available. Travel easily with event bus services."
},
{
name: "Corporate Bus Hire Pune for Events",
description: "Corporate bus hire Pune for events offers flexible rental solutions for business travel. Companies can book buses for meetings and functions. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus hire services."
},
{
name: "Corporate Event Bus Service Pune",
description: "Corporate event bus service Pune offers dependable transport for corporate functions and employee travel. Companies can arrange buses for events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible routes are available. Travel easily with bus services."
},
{
name: "Bus Booking for Corporate Events Pune",
description: "Bus booking for corporate events Pune provides easy reservation options for companies. Businesses can book buses for event transport quickly. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus booking services."
},
{
name: "Corporate Event Transport Bus Pune",
description: "Corporate event transport bus Pune provides reliable group travel for business events and conferences. Companies can arrange transport for large teams. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible routes are available. Travel easily with transport bus services."
},
{
name: "Corporate Event Bus Hire Pune",
description: "Corporate event bus hire Pune offers convenient rental services for company events. Businesses can book buses for employee and guest transport. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus hire services."
},
{
name: "Corporate Event Bus Booking Pune",
description: "Corporate event bus booking Pune provides quick booking solutions for business travel. Companies can reserve buses easily for events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus booking services."
},
{
name: "Corporate Group Bus Rental Pune",
description: "Corporate group bus rental Pune offers large-scale transport for employees and teams. Companies can book buses for events and outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible scheduling options are available. Travel easily with group bus services."
},
{
name: "Office Event Bus Service Pune",
description: "Office event bus service Pune provides reliable transport for company functions and celebrations. Businesses can arrange travel for staff easily. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with office event bus services."
},
{
name: "Company Event Bus Rental Pune",
description: "Company event bus rental Pune offers organized group transport for business events. Companies can manage travel for employees and guests. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible booking options are available. Travel easily with event bus services."
},
{
name: "Corporate Function Bus Hire Pune",
description: "Corporate function bus hire Pune provides efficient transport for meetings and corporate gatherings. Businesses can book buses for events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus hire services."
},
{
name: "Business Event Bus Rental Pune",
description: "Business event bus rental Pune offers reliable group transport for conferences and meetings. Companies can arrange travel for teams and clients. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus rental services."
},
{
name: "Corporate Bus Rental Pune for Events",
description: "Corporate bus rental Pune for events provides flexible transport solutions for companies. Businesses can book buses for corporate functions. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus rental services."
},
{
name: "Corporate Event Travel Bus Pune",
description: "Corporate event travel bus Pune offers smooth group transport for business trips and events. Companies can arrange travel efficiently. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with travel bus services."
},
{
name: "Event Bus Service Pune for Companies",
description: "Event bus service Pune for companies provides reliable transport for corporate clients. Businesses can arrange buses for events and staff travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with event bus services."
},
{
name: "Corporate Event Bus Provider Pune",
description: "Corporate event bus provider Pune offers complete transport solutions for business events. Companies can outsource travel arrangements easily. Professional drivers ensure safe journeys. Comfortable buses enhance experience. Flexible service plans are available. Travel easily with bus provider services."
},
{
name: "Corporate Event Shuttle Bus Pune",
description: "Corporate event shuttle bus Pune provides shared transport for employees and guests. Companies can arrange fixed routes for events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible scheduling options are available. Travel easily with shuttle bus services."
},
{
name: "Corporate Event Bus Service Near Me Pune",
description: "Corporate event bus service near me Pune helps businesses find nearby transport solutions quickly. Companies can book buses instantly for events. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with bus services."
}
],

tableData: [
["Bus Rental for Corporate Events in Pune","Corporate Event Bus Rental Pune"],
["Corporate Bus Hire Pune for Events","Corporate Event Bus Service Pune"],
["Bus Booking for Corporate Events Pune","Corporate Event Transport Bus Pune"],
["Corporate Event Bus Hire Pune","Corporate Event Bus Booking Pune"],
["Corporate Group Bus Rental Pune","Office Event Bus Service Pune"],
["Company Event Bus Rental Pune","Corporate Function Bus Hire Pune"],
["Business Event Bus Rental Pune","Corporate Bus Rental Pune for Events"],
["Corporate Event Travel Bus Pune","Event Bus Service Pune for Companies"],
["Corporate Event Bus Provider Pune","Corporate Event Shuttle Bus Pune"],
["Corporate Event Bus Service Near Me Pune","Corporate Event Bus Rental Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Bus Rental for Corporate Events in Pune",
    WhyChoosedescription: "SRS Cab Service offers premium bus rental for corporate events in Pune including conferences, seminars, corporate outings, exhibitions, and office gatherings with well-maintained buses and professional drivers."
  },
  {
    WhyChooseheading: "Customized Event Transport Planning",
    WhyChoosedescription: "We provide fully customized bus rental solutions including route planning, multiple pickup points, shuttle services, and dedicated buses based on event requirements."
  },
  {
    WhyChooseheading: "Wide Range of Bus Options",
    WhyChoosedescription: "Choose from 17 seater, 25 seater, 32 seater, 40 seater, and 50 seater AC buses suitable for small teams to large corporate groups."
  },
  {
    WhyChooseheading: "On-Time Pickup & Smooth Coordination",
    WhyChoosedescription: "We ensure timely pickup and drop for all employees and guests with proper coordination, helping your corporate event run smoothly without delays."
  },
  {
    WhyChooseheading: "Professional Drivers & Corporate Etiquette",
    WhyChoosedescription: "Our drivers are trained, verified, and experienced in handling corporate clients, ensuring safe, polite, and professional service."
  },
  {
    WhyChooseheading: "24/7 Availability for Event Flexibility",
    WhyChoosedescription: "Our bus rental service operates 24/7 to support early morning events, late-night functions, and multi-day corporate programs."
  },
  {
    WhyChooseheading: "GPS Tracking & Safety Features",
    WhyChoosedescription: "All buses are equipped with GPS tracking for real-time monitoring, ensuring employee safety and efficient route management."
  },
  {
    WhyChooseheading: "Trusted Corporate Bus Rental Provider",
    WhyChoosedescription: "SRS Cab Service is trusted by corporates in Pune for reliable, affordable, and well-managed bus rental services for corporate events."
  }
]
}

const faqData = [
  { 
    question: "Do you provide bus rental for corporate events in Pune?", 
    answer: "Yes, SRS Cab Service offers reliable bus rental for corporate events in Pune including conferences, office outings, exhibitions, and corporate gatherings with complete transport solutions." 
  },
  { 
    question: "Can bus rental services be customized for events?", 
    answer: "Yes, we provide customized bus rental plans including route planning, multiple pickup points, shuttle services, and dedicated buses based on event requirements." 
  },
  { 
    question: "What types of buses are available for corporate events?", 
    answer: "We offer 17 seater, 25 seater, 32 seater, 40 seater, and 50 seater AC buses suitable for small teams as well as large corporate groups." 
  },
  { 
    question: "Do you provide shuttle service for corporate events?", 
    answer: "Yes, we provide shuttle bus services between hotels, offices, and event venues for smooth movement of employees and guests." 
  },
  { 
    question: "Are drivers trained for corporate transport?", 
    answer: "Yes, all drivers are background-verified, trained, and experienced to handle corporate clients with professionalism and safety." 
  },
  { 
    question: "Is bus rental service available 24/7?", 
    answer: "Yes, our bus rental service operates 24/7 to support events at any time including early morning and late-night schedules." 
  },
  { 
    question: "Do you provide services in IT hubs like Hinjewadi and Baner?", 
    answer: "Yes, we provide corporate bus rental services across major areas like Hinjewadi, Baner, Wakad, Kharadi, and Viman Nagar." 
  },
  { 
    question: "Is service available for large corporate events?", 
    answer: "Yes, we provide transport solutions for both small and large-scale corporate events with flexible fleet options." 
  },
  { 
    question: "Are bus rental services affordable?", 
    answer: "Yes, we offer cost-effective bus rental solutions with transparent pricing and customized packages for corporate clients." 
  },
  { 
    question: "How can I book bus rental for corporate events?", 
    answer: "You can book bus rental service by contacting us directly. We provide quick planning, coordination, and seamless execution for your event." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Event Coordinator - Corporate Company",
    feedback:
      "We booked buses for a corporate event in Pune and the service was excellent. All buses arrived on time, were clean, and the coordination was very smooth throughout the event.",
    rating: 5
  },
  {
    id: 2,
    name: "Admin Manager - IT Firm",
    feedback:
      "Best bus rental service for corporate events in Pune. They managed transportation for a large group efficiently. Drivers were professional and service was very reliable.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];















const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Corporate Event Bus Rental Pune",
  "description": "Reliable bus rental for corporate events in Pune with SRS Cab. Book buses for office events, business gatherings, and corporate group transport. 24/7 service with luxury, AC, and non-AC buses for corporate travel.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/corporate-event-bus-rental-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Bus Rental for Corporate Events in Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable bus rental for corporate events in Pune with SRS Cab. Office and business event buses available 24/7. Luxury, AC, and non-AC buses for corporate travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busrentalforcorporateeventsinpune;